"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Link from "next/link"
import styles from "../TherapistsPage.module.css"
import { useScrollAnimations } from "../../../hooks/useScrollAnimations"

export default function FeaturesSection({ getRouteForLeaderOnboarding }) {
  useScrollAnimations(styles, styles.pillar)
  useScrollAnimations(styles, styles.featureCard)

  return [
    <section key="features-section" className={styles.featuresSection} id="features">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>
          Imagine a world where group work is the norm, not the exception
        </h2>
        <div className={"text-white text-center text-[19px]"}>
          Where healing and growing in connection with others is accessible to
          everyone, everywhere.
        </div>
        <div className={styles.threePillars}>
          <div className={styles.pillar}>
            <div className={styles.pillarIcon}>👥</div>
            <h3>Broader Referrals</h3>
            <p>
              Make it easier for professionals outside of your networks to find your
              group when seeking resources to compliment their care and support their
              clients goals.
            </p>
          </div>
          <div className={styles.pillar}>
            <div className={styles.pillarIcon}>🔍</div>
            <h3>Group search-ability</h3>
            <p>
              On this hub dedicated just to mental health groups, people can easily
              search for the kind of group they’re looking for, all in one browser
              tab.
            </p>
          </div>

          <div className={styles.pillar}>
            <div className={styles.pillarIcon}>✨</div>
            <h3>Public Mindset</h3>
            <p>
              Clients and therapists have more awareness of what groups are out
              there, cultivating the idea that group care is something they can
              return to throughout different seasons of life.
            </p>
          </div>
        </div>
        <h2 className={styles.sectionTitle}>Find the Full Range of Groups</h2>
        <div className={"text-white text-center text-[19px]"}>
          Helping people find and join in-person or virtual groups by providers
          nationwide.
        </div>
        <div className={"text-white text-center text-[19px]"}>
          With the right tools, group work can proliferate and make mental healthcare
          more accessible.
        </div>
        <div className={styles.featuresGrid}>
          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>💬 Group Therapy</h4>
            <p>
              A form or psychotherapy leveraging interpersonal dynamics facilitated
              by a licensed clinician. At times, tailored by population and modality.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>️🛠️ Workshops</h4>
            <p>
              Skill building around a certain subject area where participants get
              hands-on practice implementing tactics.{" "}
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>💛 Support Groups</h4>
            <p>
              Bring people together around a shared experience they have in common to
              foster connection, healing, and growth.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>🏕️ Retreats</h4>
            <p>
              Immersive experiences or getaways temporarily withdrawing from routine
              in order to concentrate purposefully to return with a sense of renewal.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>️📚 Peer Consultation Groups</h4>
            <p>
              Practitioners looking to receive peer feedback as equals to reflect on
              cases, share resources, and offer support each other’s clinical
              thinking.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4> 💼 Supervision Groups</h4>
            <p>
              Seasoned clinicians offering oversight, case guidance, shared
              responsibility, and structured support to ensure ethical, effective
              care and professional growth.
            </p>
          </div>
        </div>
      </div>
    </section>,
    <section
      key="cta-section"
      style={{
        padding: "4rem 0",
        background: "linear-gradient(135deg, #092c3c 0%, #00b2ff 100%)",
      }}
    >
      <div className={styles.container}>
        <div
          className={styles.ctaSection}
          style={{
            background: "rgba(255,255,255,0.1)",
            border: "1px solid rgba(255,255,255,0.2)",
          }}
        >
          <h3 style={{ color: "white" }}>
            Experience the Power of Group Care Yourself!
          </h3>
          <p className={"max-w-[658px]"} style={{ color: "rgba(255,255,255,0.9)" }}>
            Whether you're seeking to hone your professional skills, find support,
            grow and heal, or share your expertise—group settings offer a powerful
            path.
          </p>
          <div className={styles.ctaButtonsInline}>
            <Link href="/" className={styles.btnCtaSecondary}>
              Find a group
            </Link>
            <a href={getRouteForLeaderOnboarding()} className={styles.btnCtaPrimary}>
              List Your Group
            </a>
          </div>
        </div>
      </div>
    </section>,
  ]
}
